export default __webpack_public_path__ + "static/media/Q3-2.b14cf0b5.jpg";